export default __webpack_public_path__ + "static/media/Dialpad2.226d7416.svg";